<template>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <div v-for="(line, linePosition) in numbers" v-bind:key="linePosition">
          <v-row data-testid="followme-number-line">
              <v-col cols="12" sm="6">
                <vue-tel-input-vuetify
                  v-model="line.phoneNumber"
                  prepend-icon="mdi-cellphone-settings"
                  data-testid="followme-number"
                  :label="$t('settings.fme.num')"
                  :rules="phoneRules"
                  placeholder=''
                  defaultCountry="CA"
                  @input="saveNumbers()"
                  mode="international"
                ></vue-tel-input-vuetify>
              </v-col>
              <v-row class="ml-4 mt-6">
                <v-btn
                  text
                  color="red"
                  icon
                  class="mr-2"
                  data-testid="remove-followme-number"
                  :disabled="linePosition===0"
                  @click="deleteLine(linePosition)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  icon
                  data-testid="add-followme-number"
                  :disabled="numbers.length >= 5"
                  @click="addLine()">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-row>
          </v-row>
      </div>
    </v-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'settings-followme-numbers',
  data () {
    return {
      valid: true
    }
  },
  created () {
    if (this.enabled && this.numbers.length === 0) {
      this.addLine()
    }
  },
  watch: {
    valid (newValue, oldValue) {
      this.$emit('numbers-valid', newValue)
    }
  },
  computed: {
    ...mapGetters({
      fmeData: 'settings/followme',
      countryCode: 'countryCode'
    }),
    enabled () {
      return this.fmeData.enabled
    },
    getNumbers () {
      return this.fmeData.numbers.map(n => {
        return { phoneNumber: n }
      })
    },
    phoneRules () {
      return [
        v => (v && /^[0-9 ()\-+]+$/.test(v)) || this.$t('settings.fme.errInvalid'),
        v => (v && this.numbers.filter(n => n.phoneNumber === v).length === 1) || this.$t('settings.fme.errExists', { num: v })
      ]
    },
    numbers: { get () { return this.getNumbers }, set (numbers) { this.saveNumbers(numbers) } }
  },
  methods: {
    ...mapActions({
      setFollowmeNumbers: 'settings/setFollowmeNumbers'
    }),

    addLine () {
      const newLine = [{ phoneNumber: '' }]
      this.numbers = [...this.numbers, ...newLine]
      this.numbers.push(newLine[0])
    },

    deleteLine (linePosition) {
      this.numbers = this.numbers.splice(linePosition, 1)
    },

    saveNumbers () {
      const data = this.numbers.map(n => n.phoneNumber)
      this.setFollowmeNumbers(data)
    }
  }
}
</script>

<style>

</style>
